import { Departament, RequestDepartament } from "interfaces";
import { get, patch, post, remove } from "services/services.methods";
import { DepartamentPath } from "services/services.paths";

export const FetchDepartament = async () => {
  const response = await get<Departament[]>(DepartamentPath.basePath);
  return response;
};

export const CreateDepartament = async (data: RequestDepartament) => {
  const response = await post<Departament[]>(DepartamentPath.basePath, data);
  return response;
};

export const UpdateDepartament = async (
  id: number,
  data: RequestDepartament
) => {
  const response = await patch<Departament[]>(
    DepartamentPath.basePath + `/${id}`,
    data
  );
  return response;
};

export const DeleteDepartament = async (id: number) => {
  const response = await remove<Departament[]>(
    DepartamentPath.basePath + `/${id}`
  );
  return response;
};
